<template>
    <modal  :show.sync=show modalClasses="medium-sized-modal modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Create Profile</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form ref="customerForm" role="form" @submit.prevent="submit" >
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group>
                            <label>Name <span class="text-danger">*</span></label>
                            <b-form-input
                            v-model="new_customer.name"
                            type="text"
                            required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Email">
                                <b-form-input
                                v-model="new_customer.email"
                                type="email"
                                ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group>
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true, number_only: true, nric: true }"
                                :vid="'nric'"
                            >
                                <label>NRIC <span class="text-danger">*</span></label>
                                <b-form-input
                                v-model="new_customer.nric"
                                type="text"
                                 @keydown="preventNonNumericInput"
                                maxlength="12"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Company Name">
                            <b-form-input
                            v-model="new_customer.company.name"
                            type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Company Position">
                            <b-form-input
                            v-model="new_customer.company.position"
                            type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                    <!-- <el-switch
                        v-model="new_customer.is_test"
                        inactive-text="Testing Profile"
                        :active-value="1"
                        active-color="#0BC196"
                        inactive-color="#DCE3ED"
                        :inactive-value="0">
                    </el-switch> -->
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button type="submit" class="w-100" variant="primary" :disabled="invalid || is_loading_create">Create</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Switch } from 'element-ui'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

export default { 
    props:{
        show_new_customer: Boolean
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        ValidationObserver,
        ValidationProvider,
        Modal,
        [Switch.name]: Switch,
    },
    computed: {
        show: {
            get() {
                return this.show_new_customer;
            },
            set(newVal) {
                this.$emit('update:show_new_customer', newVal);
            },
        },
    },
    data(){
        return {
            new_customer:{
                name: null,
                nric: null,
                email:null,
                company: {
                    name: null,
                    position: null,
                },
                is_test: 0,
            },
            is_loading_create: false,
        }
    },
    methods:{
        submit(){
            let form = new FormData()
            form.append('name', this.new_customer.name)
            if(this.new_customer.email){
                form.append('email', this.new_customer.email)
            }
            form.append('nric', this.new_customer.nric.trim())
            if(this.new_customer.company.name){
                form.append('company_name', this.new_customer.company.name)
            }
            if(this.new_customer.company.position){
                form.append('company_position', this.new_customer.company.position)
            }
            form.append('is_test', this.new_customer.is_test)
            form.append('is_foreigner', 0)
            this.is_loading_create = true
            axios.post(services.customer + 'customers/customer.with_company', form, { headers: getHeader() })
            .then(res => {
                this.resetFormToNull(this.new_customer)
                this.notifySuccess('<b>Customer: '+res.data.data.name+'</b> - Successfully Created.')
                this.$emit('update:show_new_customer', false);
                this.is_loading_create = false
                this.$router.push('customerProfileDetails/'+res.data.data.customer_id)
            })
            .catch(e => {
                this.is_loading_create = false
                this.errorFunction(e)
            })
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        }
    }
}
</script>